import React from 'react';

// import { Container } from './styles';
import ModalCondicao from '../component/ModalCondicao/ModalCondicao';

export default function Condicoes({ blt }) {
  return (
    <div>
      <ModalCondicao blt={blt} />
    </div>
  );
}
